import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import { paths } from "../../paths/paths";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import moment from "moment";
import "moment/locale/ar";
import { useEffect, useState } from "react";
import Lang from "../../userPreferences/staticWords";
import TaskComments from "./taskComments";
import { resolver } from "../../API/middlewares/resolveRequests";
import ModalComponent from "../reusableComponents/modal";
import EditProcForm from "./editProc.js/editProcForm";
import { procData as ProcData } from "../../API/store/actions/procedure/procedure";
import AddTaskAttachments from "./addTaskAttachmentPopup";
import EditProcStatus from "./editProcStatus/procStatus";
import { formatDateLL } from "../../algorithms";
import DeleteProcAlert from "./editProc.js/deleteProc";
import { useSelector } from "react-redux";
import AttachmentsPopup from "./attachmentsPopup";
import Titlebar from "./../layout/titlebar";

const TaskDetailsCard = (props) => {
  const userToken = useSelector((state) => state.login.userToken);

  const [show, setshow] = useState({ id: null, display: false });
  const [procId, setProcId] = useState(null);
  const [data, setData] = useState(null);
  const [VisibleEditProc, setVisibleEditProc] = useState(false);
  const [VisibleEditProcStatus, setVisibleEditProcStatus] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const [showAttachmentPopup, setShowAttachmentPopup] = useState(false);

  const { setProcAdded, procAdded, procedures } = props;

  const onShowAttachments = () => {
    setShowAttachmentPopup(true);
  };
  const renderAttachmentsModal = (procedureId) => {
    return (
      <AddTaskAttachments
        procAdded={procAdded}
        setProcAdded={setProcAdded}
        procedureId={procedureId}
        show={showAttachmentPopup}
        onHide={() => setShowAttachmentPopup(false)}
      />
    );
  };

  useEffect(() => {
    if (Lang.getLanguage() === "ar") moment.locale("ar");
    else moment.locale("en");
    if (data) setVisibleEditProc(true);
  }, [data]);

  const [showTaskAttachmentsPopup, setshowTaskAttachmentsPopup] =
    useState(false);
  const [taskAttachmentsContent, settaskAttachmentsContent] = useState([]);

  const onshowTaskAttachmentsPopup = () => {
    setshowTaskAttachmentsPopup(true);
  };

  const [proc, setProc] = useState({});

  const renderTaskAttachmentsModal = (attachments) => {
    return (
      <AttachmentsPopup
        isActivity={false}
        name={proc.description}
        content={attachments}
        show={showTaskAttachmentsPopup}
        onHide={() => setshowTaskAttachmentsPopup(false)}
      />
    );
  };

  window.onclick = function (event) {
    if (
      !event.target.matches(".icon") &&
      !event.target.matches(".icon svg path")
    ) {
      var sharedowns = document.getElementsByClassName(
        `${customStyle("dropdown-menu-task")}`,
      );
      for (let i = 0; i < sharedowns?.length; i++) {
        var openSharedown = sharedowns[i];
        if (openSharedown?.classList?.contains("show")) {
          openSharedown?.classList?.remove("show");
          setshow({ id: null, display: false });
        }
      }
    }
  };
  if (procedures)
    return (
      <>
        <ModalComponent
          body={
            <DeleteProcAlert
              userToken={userToken}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              procId={procId}
              setVisible={setDeleteModalVisible}
              content={"هل تريد حذف الاجراء وملاحظاته ؟"}
            />
          }
          size={"s"}
          modalVisible={deleteModalVisible}
          setModalVisible={setDeleteModalVisible}
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={"هل انت متاكد"}
          background={"modalBackground mx-5"}
        />
        <ModalComponent
          body={
            <EditProcForm
              userToken={userToken}
              procId={procId}
              setVisible={setVisibleEditProc}
              procData={data}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />
          }
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleEditProc}
          modalVisible={VisibleEditProc}
          size={"xl"}
          title={"تعديل الاجراء"}
        />
        <ModalComponent
          body={
            <EditProcStatus
              userToken={userToken}
              procId={procId}
              setVisible={setVisibleEditProc}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />
          }
          hasImage={
            <img
              src="/assets/images/icons/status.png"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleEditProcStatus}
          modalVisible={VisibleEditProcStatus}
          size={"xl"}
          title={"تعديل حالة الاجراء"}
        />

        {/* <Titlebar title={"الإجراءات"} containerStyle={"px-xl-5 px-0 mt-3"} /> */}
        {!props?.hidecomments ? (
          <Titlebar
            title={"التعليقات"}
            containerStyle={"px-xl-5 px-0"}
            customImage="/assets/images/icons/Group 250.png"
          />
        ) : null}

        {/* <Titlebar title={"الإجراءات"} /> */}
        {procedures?.map((procedure, index) => {
          let desc = procedure?.description?.replaceAll("\n", "<br />");
          let newCreateDate, userPhoto;
          newCreateDate = procedure.createDate.split(".")[0];
          // if (procedure.memberPhoto != null)
          //   userPhoto = `url("${paths.ApplicantPhoto}${procedure.memberId}/${procedure.memberPhoto}")`;
          // else
          userPhoto = `url("/assets/images/userPlaceholder.png")`;
          return (
            <span key={index + parseInt(procedure.id) * 0.3}>
              <div
                className="mt-4"
                style={{ borderBottom: "1px solid #0c574b" }}
              >
                <div className="d-flex flex-column px-md-5 px-4 mx-4 align-items-center">
                  <div className="d-flex align-items-start col-12 justify-content-start my-2 px-3 px-md-0">
                    <div
                      style={{
                        backgroundImage: userPhoto,
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        border: "1px solid white",
                      }}
                    ></div>
                    <p className="mx-2 my-0" style={{ fontWeight: "bold" }}>
                      {procedure.memberName}
                    </p>

                    {!props?.hidecomments ? (
                      <>
                        {" "}
                        {procedure?.canDelete || procedure?.canEdit ? (
                          <Icon
                            id={procedure.id}
                            name="ellipsis-v"
                            size={18}
                            className=" d-flex icon"
                            style={{ display: "block" }}
                            onclick={(e) => {
                              const id = e.currentTarget.id;
                              id == null
                                ? setshow({
                                    id,
                                    display: true,
                                  })
                                : id == show.id
                                  ? setshow({
                                      id: null,
                                      display: false,
                                    })
                                  : setshow({
                                      id,
                                      display: true,
                                    });
                            }}
                          />
                        ) : null}
                      </>
                    ) : null}
                  </div>
                  <div className="d-flex align-items-center col-md col-12 my-2">
                    <div
                      style={{ fontSize: 14, color: "#444444" }}
                      className=""
                    >
                      {Lang.createDate}
                      <span>
                        &nbsp;&nbsp;&nbsp;
                        {`${formatDateLL(procedure.createDate)}`}
                        {/* {console.log(procedure)} */}
                      </span>
                      {/* <span>
                        &nbsp;&nbsp;{Lang.to}&nbsp;
                        {`${formatDateLL(procedure.endDate)}`}
                      </span> */}
                    </div>
                  </div>
                </div>

                <div
                  className="d-flex px-5 mx-4 align-items-center "
                  style={{
                    textAlign: "justify",
                    fontSize: 16,
                    color: "#444444",
                  }}
                >
                  <p dangerouslySetInnerHTML={{ __html: desc }} />
                </div>
              </div>

              {!props?.hidecomments ? (
                <div
                  style={{
                    backgroundColor: "#F2F2F2",
                    borderTopRightRadius: 10,
                    borderTopLeftRadius: 10,
                    borderBottom: "2px solid rgba(53, 132, 234, 0.5)",
                  }}
                  className={`d-flex flex-wrap 
                ${
                  // procedure?.taskStatus?.name || procedure?.attachments?.length
                  //   ? "justify-content-around"
                  //   :
                  "justify-content-end"
                } px-1 mx-5`}
                >
                  {/* {procedure?.taskStatus?.name ? (
                  <div
                    className={`d-flex justify-content-center align-items-center col-3 px-3`}
                    style={{
                      width: "fit-content",
                    }}
                  >
                    <div className={`${styleEnd("m", 2)}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                      >
                        <g
                          id="technical-support_1_"
                          data-name="technical-support (1)"
                          transform="translate(0 0.001)"
                        >
                          <path
                            id="Path_428"
                            data-name="Path 428"
                            d="M3.165,13.919a1.468,1.468,0,0,0-.709.181A8.3,8.3,0,0,1,10.652.867a.352.352,0,0,0,.139-.689A9.067,9.067,0,0,0,9,0,9,9,0,0,0,1.936,14.577a1.477,1.477,0,1,0,1.229-.658Zm.547,2.023a.773.773,0,1,1,.227-.547A.768.768,0,0,1,3.712,15.943Zm0,0"
                            transform="translate(0)"
                            fill={procedure?.taskStatus?.color}
                          />
                          <path
                            id="Path_429"
                            data-name="Path 429"
                            d="M206.6,34.346a1.473,1.473,0,1,0-.52.477,8.3,8.3,0,0,1-8.18,13.236.352.352,0,1,0-.138.69,9.073,9.073,0,0,0,1.775.175A9,9,0,0,0,206.6,34.346Zm-1.776-.272a.774.774,0,1,1,.547.226A.768.768,0,0,1,204.828,34.074Zm0,0"
                            transform="translate(-190.541 -30.925)"
                            fill={procedure?.taskStatus?.color}
                          />
                          <path
                            id="Path_430"
                            data-name="Path 430"
                            d="M78.932,86.445a.352.352,0,0,0,.352.352h2.2a.352.352,0,0,0,.352-.352v-.682a5.505,5.505,0,0,0,1.319-.547l.481.481a.351.351,0,0,0,.5,0l1.554-1.555a.352.352,0,0,0,0-.5l-.481-.481a5.5,5.5,0,0,0,.547-1.319h.679a.352.352,0,0,0,.352-.352V79.3a.352.352,0,0,0-.352-.352h-.679a5.505,5.505,0,0,0-.547-1.319l.478-.478a.352.352,0,0,0,0-.5L84.127,75.1a.352.352,0,0,0-.5,0l-.477.477a5.5,5.5,0,0,0-1.319-.547v-.675A.352.352,0,0,0,81.482,74h-2.2a.352.352,0,0,0-.352.352v.675a5.5,5.5,0,0,0-1.319.547l-.477-.477a.352.352,0,0,0-.5,0L75.084,76.65a.351.351,0,0,0,0,.5l.478.478a5.5,5.5,0,0,0-.547,1.319h-.678a.352.352,0,0,0-.352.351v2.2a.351.351,0,0,0,.352.352h.679a5.506,5.506,0,0,0,.547,1.319l-.481.481a.352.352,0,0,0,0,.5L76.635,85.7a.352.352,0,0,0,.249.1h0a.352.352,0,0,0,.249-.1l.481-.481a5.51,5.51,0,0,0,1.319.547Zm-1.182-1.968a.352.352,0,0,0-.439.047l-.428.428-1.057-1.058.428-.428a.351.351,0,0,0,.047-.439,4.812,4.812,0,0,1-.666-1.607.352.352,0,0,0-.344-.278h-.6v-1.5h.6a.352.352,0,0,0,.344-.278,4.812,4.812,0,0,1,.666-1.607.351.351,0,0,0-.047-.439l-.425-.425,1.058-1.057.424.425a.352.352,0,0,0,.439.047,4.81,4.81,0,0,1,1.607-.666.352.352,0,0,0,.278-.344v-.6h1.5v.6a.351.351,0,0,0,.278.344,4.814,4.814,0,0,1,1.607.666.351.351,0,0,0,.439-.047l.425-.424L84.937,76.9l-.425.425a.351.351,0,0,0-.047.439,4.815,4.815,0,0,1,.666,1.607.351.351,0,0,0,.344.278h.6v1.5h-.6a.352.352,0,0,0-.344.278,4.811,4.811,0,0,1-.666,1.607.352.352,0,0,0,.047.439l.428.428-1.057,1.058-.428-.428a.351.351,0,0,0-.439-.047,4.815,4.815,0,0,1-1.607.666.352.352,0,0,0-.278.344v.607h-1.5v-.607a.352.352,0,0,0-.278-.344A4.812,4.812,0,0,1,77.751,84.477Zm0,0"
                            transform="translate(-71.384 -71.399)"
                            fill={procedure?.taskStatus?.color}
                          />
                          <path
                            id="Path_431"
                            data-name="Path 431"
                            d="M179.181,176.276a2.9,2.9,0,1,0-2.9,2.9A2.908,2.908,0,0,0,179.181,176.276Zm-5.107,0a2.2,2.2,0,1,1,2.2,2.2A2.2,2.2,0,0,1,174.074,176.276Zm0,0"
                            transform="translate(-167.277 -167.277)"
                            fill={procedure?.taskStatus?.color}
                          />
                          <path
                            id="Path_432"
                            data-name="Path 432"
                            d="M338.43,18.512a.352.352,0,1,0-.248-.1A.354.354,0,0,0,338.43,18.512Zm0,0"
                            transform="translate(-326.193 -17.183)"
                            fill={procedure?.taskStatus?.color}
                          />
                          <path
                            id="Path_433"
                            data-name="Path 433"
                            d="M154.711,474.359a.352.352,0,1,0,.249.1A.355.355,0,0,0,154.711,474.359Zm0,0"
                            transform="translate(-148.933 -457.683)"
                            fill={procedure?.taskStatus?.color}
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <p className="my-0">{procedure?.taskStatus?.name}</p>
                    </div>
                  </div>
                ) : null} */}

                  {procedure?.attachments?.length > 0 ? (
                    <div
                      className="d-flex justify-content-start align-items-center col-10 py-3"
                      style={{ cursor: "pointer" }}
                    >
                      <a
                        href={`${
                          procedure?.attachments[0]?.taskProcedureId
                            ? paths.TaskProcedureAttachments
                            : paths.TasksAttachments
                        }${
                          procedure?.attachments[0]?.taskProcedureId ??
                          procedure?.attachments[0]?.taskId ??
                          0
                        }/${procedure?.attachments[0]?.id}/${
                          procedure?.attachments[0]?.attachment
                        }`}
                        className={`d-flex align-items-center hoverLinks text-decoration-none`}
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 16.049 15.568"
                          className={`${styleEnd("m", 1)}`}
                        >
                          <path
                            id="ic_attachment_24px"
                            d="M0,3.972A3.97,3.97,0,0,1,3.972,0h7.583a2.889,2.889,0,1,1,0,5.777H5.416a1.805,1.805,0,1,1,0-3.611h5.416V3.611H5.351c-.4,0-.4.722,0,.722h6.2a1.444,1.444,0,1,0,0-2.889H3.972a2.528,2.528,0,1,0,0,5.055h6.861V7.944H3.972A3.97,3.97,0,0,1,0,3.972Z"
                            transform="translate(0 9.664) rotate(-42)"
                          />
                        </svg>

                        <div>
                          {/* filename here */}
                          <p className="m-0 ">
                            {procedure?.attachments[0]?.attachment}
                          </p>
                        </div>
                      </a>

                      <a
                        download
                        href={`${
                          procedure?.attachments[0]?.taskProcedureId
                            ? paths.TaskProcedureAttachments
                            : paths.TasksAttachments
                        }${
                          procedure?.attachments[0]?.taskProcedureId ??
                          procedure?.attachments[0]?.taskId ??
                          0
                        }/${procedure?.attachments[0]?.id}/${
                          procedure?.attachments[0]?.attachment
                        }`}
                        className={`${styleStart("m", 3)}`}
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="16"
                          viewBox="0 0 14 17"
                        >
                          <path
                            id="ic_file_download_24px"
                            d="M19,9H15V3H9V9H5l7,7ZM5,18v2H19V18Z"
                            transform="translate(-5 -3)"
                            fill="#12aac4"
                          />
                        </svg>
                      </a>

                      {procedure?.attachments?.length > 1 ? (
                        <div
                          id={procedure.id}
                          className="d-flex align-items-center justify-content-start me-5 position-relative"
                          style={{ cursor: "pointer" }}
                        >
                          <div className="position-absolute">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="26"
                              height="26"
                              viewBox="0 0 16.049 15.568"
                            >
                              <path
                                id="ic_attachment_24px"
                                d="M0,3.972A3.97,3.97,0,0,1,3.972,0h7.583a2.889,2.889,0,1,1,0,5.777H5.416a1.805,1.805,0,1,1,0-3.611h5.416V3.611H5.351c-.4,0-.4.722,0,.722h6.2a1.444,1.444,0,1,0,0-2.889H3.972a2.528,2.528,0,1,0,0,5.055h6.861V7.944H3.972A3.97,3.97,0,0,1,0,3.972Z"
                                transform="translate(0 9.664) rotate(-42)"
                              />
                            </svg>
                          </div>

                          <div
                            className={`position-absolute ${customStyle(
                              "attachmentsNumber",
                            )}`}
                            onClick={() => {
                              onshowTaskAttachmentsPopup();
                              setProc(procedure);
                              if (procedure?.attachments?.length > 0)
                                settaskAttachmentsContent(
                                  procedure?.attachments,
                                );
                              else settaskAttachmentsContent(null);
                            }}
                          >
                            <div
                              className={`d-flex justify-content-center align-items-center ${styleEnd(
                                "m",
                                2,
                              )}`}
                              style={{
                                color: "white",
                                backgroundColor: "#1A73E8",
                                borderRadius: "50%",
                                minWidth: "fit-content",
                                minHeight: "fit-content",
                                width: 22,
                                height: 22,
                                fontSize: 12,
                              }}
                            >
                              {procedure?.attachments?.length}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ) : null}

                  {procedure?.attachments?.length == 0 ? (
                    <div className="d-flex justify-content-center align-items-center col-10 py-3"></div>
                  ) : null}

                  <div
                    id={procedure.id}
                    className="d-flex align-items-center justify-content-center py-4 mx-3 position-relative col-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      const id = e.currentTarget.id;
                      // resolver(getComments, setComments, procedure?.id, userToken);
                      id == null
                        ? props.setDisplayComments({
                            id,
                            display: true,
                            content: [...procedure.comments],
                            owner: {
                              memberId: procedure.memberId,
                              memberName: procedure.memberName,
                              memberPhoto: procedure.memberPhoto,
                              description: procedure.description,
                              createDate: procedure.createDate,
                            },
                          })
                        : id == props.displayComments.id
                          ? props.setDisplayComments({
                              id: null,
                              display: false,
                              content: [],
                              owner: {},
                            })
                          : props.setDisplayComments({
                              id,
                              display: true,
                              content: [...procedure.comments],
                              owner: {
                                memberId: procedure.memberId,
                                memberName: procedure.memberName,
                                memberPhoto: procedure.memberPhoto,
                                description: procedure.description,
                                createDate: procedure.createDate,
                              },
                            });
                    }}
                  >
                    <div
                      className="position-absolute"
                      style={{
                        top: 12,
                      }}
                    >
                      <svg
                        id="fi-br-comment-alt"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 16 15.851"
                      >
                        <path
                          id="Path_74"
                          data-name="Path 74"
                          d="M12.333,0H3.667A3.671,3.671,0,0,0,0,3.667v6a3.671,3.671,0,0,0,3.667,3.667h.959l2.733,2.285a1,1,0,0,0,1.283,0l2.733-2.285h.959A3.671,3.671,0,0,0,16,9.667v-6A3.671,3.671,0,0,0,12.333,0ZM14,9.667a1.667,1.667,0,0,1-1.667,1.667H11.011a1,1,0,0,0-.641.233L8,13.548,5.63,11.567a1,1,0,0,0-.641-.233H3.667A1.667,1.667,0,0,1,2,9.667v-6A1.667,1.667,0,0,1,3.667,2h8.667A1.667,1.667,0,0,1,14,3.667Z"
                          fill="black"
                        />
                        <path
                          id="Path_75"
                          data-name="Path 75"
                          d="M7.167,8.333H9.5A1.167,1.167,0,0,0,9.5,6H7.167a1.167,1.167,0,0,0,0,2.333Z"
                          transform="translate(-2.667 -2.289)"
                          fill="black"
                        />
                        <path
                          id="Path_76"
                          data-name="Path 76"
                          d="M14.853,11H7.265a1.265,1.265,0,0,0,0,2.529h7.588a1.265,1.265,0,0,0,0-2.529Z"
                          transform="translate(-3 -3.196)"
                          fill="black"
                        />
                      </svg>
                    </div>

                    <div
                      className={`mx-2 position-absolute ${customStyle(
                        "commentsNumber",
                      )}`}
                    >
                      <div
                        className={`d-flex justify-content-center align-items-center ${styleEnd(
                          "m",
                          2,
                        )}`}
                        style={{
                          color: "white",
                          backgroundColor: "#1A73E8",
                          borderRadius: "50%",
                          minWidth: "fit-content",
                          minHeight: "fit-content",
                          width: 22,
                          height: 22,
                          fontSize: 12,
                        }}
                      >
                        {procedure.comments.length}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {props.displayComments.id == procedure.id ? (
                <TaskComments
                  commentsUnderProcedure={props.commentsUnderProcedure}
                  procedures={procedures}
                  displayComments={props.displayComments}
                  setDisplayComments={props.setDisplayComments}
                />
              ) : null}
            </span>
          );
        })}
        {renderAttachmentsModal(procId)}
        {renderTaskAttachmentsModal(taskAttachmentsContent)}
      </>
    );
  return <></>;
};

export default TaskDetailsCard;
